<template>
<div>
  <v-row no-gutters>
    <v-col class="pa-0 mb-5 col-auto">
      <validation-provider v-slot="{ errors }" :rules="{required: {allowFalse: false}}"
                           name="利用規約および個人情報の取り扱いについて同意します">
        <v-checkbox
          v-model="isAgreedWithTermsAndPrivacy"
          :error-messages="errors"
          type="checkbox"
          dense
          height="auto"
          name="agreedWithTermsAndPrivacy"
          :ripple="false"
          :class="{'agreement-checkbox' : $vuetify.breakpoint.mdAndUp}"
          hide-details="auto"
        >
          <template #label>
            <div class="text-body-2">
              <v-tooltip disabled>
                <template v-slot:activator="{ on }">
                  <a class="black--text text-decoration-underline" :href="ruleHref" target="_blank" @click.stop v-on="on">{{ rulesLabel }}</a>
                </template>
              </v-tooltip>
              および
              <v-tooltip disabled>
                <template v-slot:activator="{ on }">
                  <a class="black--text text-decoration-underline" :href="privacyHref" target="_blank" @click.stop v-on="on">個人情報</a>
                </template>
              </v-tooltip>
              の取り扱いについて同意します
            </div>
          </template>
        </v-checkbox>
      </validation-provider>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  name: "vb-terms-of-service",
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formItemsGetter: {
      type: Object,
      required: true,
      default: {}
    },
  },
  computed: {
    isAgreedWithTermsAndPrivacy: {
      get() {
        return this.formItemsGetter.isAgreedWithTermsAndPrivacy;
      },
      set(event) {
        this.formItemsSetter({name: 'isAgreedWithTermsAndPrivacy', value: Boolean(event)})
      }
    },
    ruleHref() {
      let href;
      switch (this.$siteCode){
        case VueConfig.siteCode.valuebooks:
          href = "/rules";
          break
        case VueConfig.siteCode.vaboo:
          href =  this.formItemsGetter.isAgreedCreateMainSiteAccount ? "https://www.valuebooks.jp/rules" : "/kiyaku.html";
          break
        case VueConfig.siteCode.charibon:
          if (this.formItemsGetter.campaignCode) {
            for(const coupon of VueConfig.sell.charibonTerms.coupons) {
              if (coupon.code.toLowerCase() == this.formItemsGetter.campaignCode.toLowerCase()) {
                // 大文字小文字を無視して比較する
                href = coupon.url;
                break;
              }
            }
          }
          if (!href) {
            href = VueConfig.sell.charibonTerms.default;
          }
          break
        default:
          href = "/rules";
          break
      }
      return href
    },
    privacyHref() {
      let href
      switch (this.$siteCode){
        case VueConfig.siteCode.valuebooks:
          href = "/privacy";
          break
        case VueConfig.siteCode.vaboo:
          href = "https://www.valuebooks.jp/privacy";
          break
        case VueConfig.siteCode.charibon:
          href = "https://www.valuebooks.jp/privacy";
          break
        default:
          href = "https://www.valuebooks.jp/privacy";
          break
      }
      return href
    },
    rulesLabel() {
      let label;
      switch (this.$siteCode){
        case VueConfig.siteCode.valuebooks:
          label = "利用規約";
          break
        case VueConfig.siteCode.vaboo:
          label =  this.formItemsGetter.isAgreedCreateMainSiteAccount ? "バリューブックス 利用規約" : "Vaboo 利用規約";
          break
        case VueConfig.siteCode.charibon:
          label = "charibon 利用規約";
          break
        default:
          label = "利用規約";
          break
      }
      return label
    },
  }
}
</script>

<style scoped lang="scss">
.row {
  margin-top: 0;
  margin-bottom: 0;
}

::v-deep {
  #checkbox-multilines label {
    display: block;
  }

  .v-input--checkbox {
    label {
      color: rgba(0, 0, 0, 0.87);
    }
    .v-input__slot {
      align-items: flex-start;
    }
  }
  .agreement-checkbox {
    .v-icon {
      font-size: 28px;
    }
  }
}
</style>